import { b as convert } from './chunk-2f890094.js';



export default convert;



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/rtl-css-js/dist/esm/index.js
// module id = 424
// module chunks = 5 6